import axios from "axios";
import Events from "../utilities/EventEmitter";
import appConstant, { HTTP_METHOD } from "../appConstants";
import sendRequestWithDeduplication from "./sendRequestWithDeduplication";
// import * as  mockAPI from "./mock"

// Add GET API endpoints here
const GET_API_URLS = {
  GetIBPlanningConfiguration: "/api/Settings/getWebAppConfig",
  GetDispatchConfiguration: "/api/citydispatch/getWebAppConfig",
  ShipmentsGrid: "/api/Shipment/GetAllShipments",
  IBShipmentsGrid: "/api/Shipment/GetPlannedShipments",
  RoutesGrid: "/api/Route/GetRoutes",
  StopsGrid: "/api/Stop/GetRouteStops",
  GetParameters: "/api/Settings/GetParameters",
  GetStemMiles: "/api/Settings/GetSpeedProfileForStemMile",
  GetZoneMiles: "/api/Settings/GetSpeedProfileForZoneMile",
  GetWaves: "/api/Settings/GetWaveDetails",
  GetAllTrailers: "/api/Settings/GetAllTrailers",
  GetScenarios: "/api/Settings/GetScenarios",
  GetAnchorPoints: "/api/Settings/GetAnchorPoints",
  IBKPIs: "/api/KPIs/GetIBKPIs",
  GetQuickFilters: "/api/User/GetQuickFilters",
  GetUserInfo: "/api/User/GetUserInfo",
  GetUNRTDReasons: "/api/Route/GetUNRTDReasons",
  GetAllUsers: "/api/User/GetAllUsers",
  GetAllTerminals: "/api/User/GetAllTerminals",
  GetTerminalKPIGoals: "/api/Settings/GetTerminalKPIGoals",
  GetIBPlanningEnableFeaturesByTerminal: "/api/Settings/GetEnabledFeaturesByTerminal",
  GetProImages: "/api/reporting/GetImagePaths",
  GetDispatchEnableFeaturesByTerminal: "/api/citydispatch/getEnabledFeaturesByTerminal",
  GetDriverPreferences: "/api/Settings/GetDriverPreferences",
  GetGroupedDriverPreferences: "/api/Settings/GetGroupedDriverPreferences",
  GetNewShipments: "/api/shipment/GetNewShipments",
  GetAllNotifications: "/api/Notification/GetAllNotifications",
  GetActiveNotificationForUser: "/api/Notification/GetActiveNotificationForUser",
  GetPublishedTerminals: "/api/Reports/GetPublishedTerminals",
  GetRouteMapping: "/api/settings/getRouteMapping",
  GetRouteComplianceData: "/api/reporting/getRouteComplianceData",
  GetNextStopComplianceGridData: "/api/reporting/getNextStopComplianceGridData",
  GetRouteComplianceKPI: "/api/reporting/getRouteComplianceKPI",
  GetLatestNSCReportDate: "/api/reporting/getLatestNSCReportDate",
  GetShipperConsignee: "/api/citydispatch/getShipperConsignee",
  GetLocationMapping: "/api/citydispatch/getLocationMapping",
  GetBolDetails: "/api/citydispatch/getBolDetails",
  GetClientCodes: "/api/settings/getClientCodes",
  GetDockComplianceReport: "/api/Reports/getComplianceData", /* DCR APIs */
  GetDockComplianceLatestReportDate: "/api/reports/getLatestDCReportDate",
  GetShipmentDetails: "/api/Reports/getShipmentDetails",
  GetDockComplianceKPIs: "/api/Reports/getComplianceKPI", /* End DCR APIs */
  GetRouteEquipmentPreference: "/api/Settings/GetRouteTrailerPreference",
  GetProHistory: "/api/Reports/GetProHistory",
  GetPlanningKPIReportCharts: "/api/ibpreporting/getIBPlanningKPIForDateRange",
  GetPlanningKPIReportForRoutes: "/api/Reports/getKPIReportForRoutes",
  GetDuplicateCustomer: "/api/Reports/getDuplicateCustomer",
  GetDuplicateCustomerForTerminal: "/api/Reports/getDuplicateCustomerForTerminal",
  GetDispatchKPIReportCharts: "/api/reporting/getDispatchKPIForDateRange",
  GetDispatchKPIReportForRoutes: "/api/reporting/getRouteLevelKpi",
  GetFreightBillDetails: "/api/citydispatch/getFreightBillDetails",
  GetGeofenceData: "/api/Settings/getGeofencingData",
  DispatchedDrivers: "/api/citydispatch/getAllDispatchRoutes",
  DispatchTractors: "/api/citydispatch/getTractors",
  GetDispatchFilter: "/api/citydispatch/getDispatchFilter",
  GetAllMessages: "/api/citydispatch/getAllMessages",
  ProjectedDispatchKPI: "/api/citydispatch/getProjectedKPI",
  DispatchKPI: "/api/citydispatch/getDispatchKPI",
  getClientData: "/api/citydispatch/getClientCodes",
  getAllPackageCodes: "/api/citydispatch/getAllPackageCodes",
  GetAllHazmatInfo: "/api/citydispatch/getAllHazmatInfo",
  GetDispatchGroupMessages: "/api/citydispatch/getGroupMessages",
  GetCustomerDetail: "/api/customer/getCustomerDetail",
  GetCustomerGeoFence: "/api/customer/getCustomerGeoFence",
  GetCustomerRoutes: "/api/customer/getCustomerRoutes",
  GetUnreadMessages: "/api/citydispatch/getUnreadMessages",
  GetAllEquipment: "/api/citydispatch/getAllEquipment",
  GetEquipmentsTerminalsMoveRules: "/api/citydispatch/GetTerminalsToMoveEquipments",
  GetEquipmentStatusRules: "/api/citydispatch/GetEquipmentStatusUpdateRules",
  GetAllTerminalsToMoveEquipments: "/api/citydispatch/GetAllTerminalsToMoveEquipments",
  GetAvailableDrivers: "/api/citydispatch/getScheduledDrivers",
  DriverPerformance: "/api/reporting/getDriverPerformanceReport",
  GetProDetails: "/api/citydispatch/getShipment",
  CustomerReceiver: "/api/citydispatch/getCustomerReceiver",
  GetTerminalsToMovePickup: "/api/citydispatch/getTerminalsToMovePickup",
  DriverPerformanceHistoricData: "/api/reporting/getHistoricalDriverPerformanceReport",
  GetShippersAtTerminal: "/api/cityDispatch/getShippersAtTerminal",
  GetAllAppTerminals: "/api/citydispatch/getAllTerminals",
  PickupRestrictions: "/api/citydispatch/getPickupRestrictions",
  GetMergedCustomers: "/api/reports/getMergedCustomers",
  GetImages: "/api/citydispatch/getStopImagesBlob",
  GetDriverImages: "/api/citydispatch/getDriverImagesBlob",
  SpottedTrailer: "/api/citydispatch/getSpottedTrailers",
  StopChangeHistory: "/api/citydispatch/getStopChangeHistory",
  GetDuplicatePickups: "/api/citydispatch/getAllDuplicatePickups",
  GetReturnShipments: "/api/citydispatch/getReturnShipments",
  GetPriorityShipments: "/api/citydispatch/getPriorityShipments",
  GetAccessibleTerminal: "/api/citydispatch/getAllSplitTerminals",
  CustomerLocationMapping: "/api/customer/getCustomerLocationMapping",
  GetDeliveryLocationMapping: "/api/customer/getDeliveryLocationMapping",
  SearchRecord: "/api/Reporting/getRecordsLookupReport",
  StopImages: "/api/Reporting/getStopImages",
  MessageHistory: "/api/reporting/getMessageHistory",
  ValidatePro: "/api/citydispatch/validatePro",
  GetReturnShipmentsForPlan: "/api/shipmentselection/getReturnShipmentsForPlanning",
  GetInboundBills: "/api/shipmentselection/getInboundBillsForPlanning",
  GetInitializedPlanDates: "/api/shipmentselection/getInitializedPlanDates",
  GetValidHolidays: "/api/holiday/getValidHolidays",
  GetStagingEvents: "/api/reports/getStagingEvents",
  GetFeederTerminal: "/api/settings/getFeederTerminal",
  GetShipmentsToAdd: "/api/shipmentselection/getShipmentsToAdd",
  GetStripPriorityData: "/api/reports/getStripPriorityData",
  GetDoorData: "/api/settings/getDoorData",
  GetAllHolidays: "/api/holiday/getAllHolidays",
  PickupRecommendations: "/api/citydispatch/getPickupRecommendations",
  PickupRecommendationKPI: "/api/citydispatch/getPickupRecommendationsKPI",
  GetDeliveryStopData: "/api/citydispatch/getShipmentDetails",
  GetHolidaysAccessibleToTerminal: "/api/holiday/getHolidaysAccessibleToUser",
  GetTerminalHolidays: "/api/holiday/getTerminalHolidays",
  GetPickupHistory : "/api/reporting/getPickupHistory",
  GetAllPastPickups: "/api/reporting/getPastPickups",
  ValidateHoliday: "/api/holiday/validateHoliday",
  GetTutorialData: "/api/apptutorial/getAppTutorialData",
  GetCustomerReceivers : "/api/citydispatch/getCustomerReceiversForMgmt",
  GetDriverNotes: "/api/customer/getDriverCustomerNotes",
  GetReportingPickupDetails : "/api/Reporting/getPickupDetails",
  GetReportingProDetails : "/api/Reporting/getProDetails",
  GetReportFreightBillDetails : "/api/Reporting/getReportFreightBillDetails",
  GetIBplanningPro : "/api/shipmentselection/getShipmentFromMaster",
  GetTrailersToAdd : "/api/settings/getTrailersToAdd",
  GetShipmentForecastForTerminal: "/api/shipmentforecast/GetShipmentForecastForTerminal",
  GetCustomersForTerminalForecast: "/api/shipmentforecast/GetCustomersForTerminalForecast",
  GetShipmentForecastForNetwork: "/api/shipmentforecast/GetShipmentForecastForNetwork",
  GetCustomersForNetworkForecast: "/api/shipmentforecast/GetCustomersForNetworkForecast",
  GetDispatchEvents: "/api/reporting/getDispatchEvents",
  GetHoldData: "/api/terminalSetting/getHoldData",
  SearchHoldData: "/api/terminalSetting/getCustomerShipper",
  GetGPSData: "/api/reporting/getGPSData",
  GetClosedTrailers: "/api/citydispatch/getClosedTrailers",
  GetClosedTrailerContents: "/api/citydispatch/getShipmentDetailsInRoute",
  GetPickupsForSwapBoard: "/api/citydispatch/getPickupsForSwapBoard",
  GetRouteProMapping: "/api/ibpreporting/getRouteProMapping",
  GetShipmentRouteHistory: "/api/ibpreporting/getShipmentRouteHistory",
};

// Add Get API which is used as Post call
export const GET_API_USED_AS_POST = {
  PickupsGrid: '/api/citydispatch/getAllPickups',
  Recommendations: '/api/citydispatch/getDispatchRouteRecommendations',
  GetPickupShipments: '/api/citydispatch/getPickupShipments',
  GetNearbyRoutes: '/api/Route/GetNearbyRoutes',
  SetUserPreferences: "/api/User/SetUserPreferences", //exception case: if is post API call and used as Post call only, we want read-only user to make post call to set there preference
  RefreshRecommendations: "/api/dispatch/app/pickup/refreshRecommendations", //this post call should be allowed for read-only role
  GetPastPickupShipments: '/api/reporting/GetPastPickupShipmentDetails',
  GetPickupDuplicates: '/api/dispatch/app/pickup/getPickupDuplicates',
  DisableNotification: "/api/Notification/DisableNotification",
  ForceDriverLogout :"/api/dispatch/app/ForceDriverLogout", //this post call should be allowed for read-only role
  GetDuplicateCustomerAdditionalDetails:"/api/reports/getDuplicateCustomerAdditionalDetails",
  GetInputValidationForDynamicRouting: "/api/engine/getInputValidationForDynamicRouting",
  SyncShipperOnDemand: "/api/customer/syncShipperOnDemand",
  getDynamicRoutingUsageReport: "/api/ibpreporting/getDynamicRoutingUsageReport",
  GetRouteAudit: "/api/reporting/getRouteAudit",
  GeneratePhysicalDR: "/api/dispatch/app/customer/generatePhysicalDR"
}

// Add POST API endpoints here
const POST_API_URLS = {
  ...GET_API_USED_AS_POST,
  SetRouteTermination: "/api/Route/SetRouteTermination",
  MergeRoutes: "/api/Route/MergeRoutes",
  CreateRoute: "/api/Route/CreateRoute",
  ConvertRoutes: "/api/Route/ConvertRoutes",
  UpdateLastStop: "/api/Stop/UpdateLastStop",
  UpdateStopSequence: "/api/Stop/UpdateStopSequence",
  UpdateRouteStops: "/api/Stop/UpdateRouteStops",
  UpdateRouteStopTime: "/api/Stop/UpdateRouteStopTime",
  runTSP: "/api/engine/RunTSP",
  UpdateRoutes: "/api/Route/UpdateRoutes",
  UpdateRouteStopsFromMap: "/api/Stop/UpdateRouteStopsFromMap",
  UpdateShipmentsProperty: "/api/Shipment/UpdateShipmentsProperty",
  UpdateShipmentRouteAssignment: "/api/Shipment/UpdateShipmentRouteAssignment",
  UpdateParameters: "/api/Settings/UpdateParameters",
  UpdateStemMiles: "/api/Settings/UpdateSpeedProfileForStemMile",
  DeleteStemMiles: "/api/Settings/DeleteSpeedProfileForStemMile",
  UpdateZoneMiles: "/api/Settings/UpdateSpeedProfileForZoneMile",
  DeleteZoneMiles: "/api/Settings/DeleteSpeedProfileForZoneMile",
  UpdateWave: "/api/Settings/UpdateWave",
  DeleteWave: "/api/Settings/DeleteWave",
  UpdateTrailers: "/api/Settings/UpdateTrailers",
  EditScenario: "/api/Settings/EditScenario",
  UpdateRouteAnchorPoint: "/api/Route/UpdateRouteAnchorPoint",
  UpdateAnchorPoint: "/api/Settings/UpdateAnchorPoint",
  UpdateBulkAnchorPoint: "/api/settings/updateBulkAnchorPoint",
  UpdateFirstStop: "/api/Stop/UpdateFirstStop",
  TriggerDynamicRouting: "/api/Engine/TriggerDynamicRouting",
  PublishRoutes: "/api/routes/publish",
  CreateUserPasswordFlow: "/api/User/createUserPasswordFlow",
  CreateUserEmailFlow: "/api/User/createUserEmailFlow",
  UpdateUser: "/api/User/updateUser",
  DeleteUser: "/api/User/deleteUser",
  UpdateTerminalKPIGoals: "/api/Settings/UpdateTerminalKPIGoals",
  UpdateShipmentCustomerLocation: "/api/Customer/UpdateCustomerLocation",
  UpdateDriverPreferences: "/api/Settings/UpdateDriverPreferences",
  UpdateGroupedDriverPreferences: "/api/Settings/UpdateGroupedDriverPreferences",
  DeleteGroupedDriverPreferences: "/api/Settings/DeleteGroupedDriverPreferences",
  Undo: "/api/route/Undo",
  CreateOrUpdateNotification: "/api/Notification/CreateOrUpdateNotification",
  DeleteNotification: "/api/Notification/DeleteNotification",
  CreateAnchorPoint: "/api/Settings/createAnchorPoint",
  DeleteAnchorPoint: "/api/Settings/deleteAnchorPoint",
  UpdateCustomerTrailerLengthPreference: "/api/customer/updateCustomerProperties",
  DeleteRouteMapping: "/api/settings/deleteRouteMapping",
  saveRouteMapping: "/api/settings/saveRouteMapping",
  CopyRouteMapping: "api/settings/copyRouteMapping",
  MergeCustomers: "/api/customer/mergeCustomers",
  MergeCustomerFromReport: "/api/reports/mergeCustomer",
  PrintLoadingManifest: "/api/Route/PrintLoadingManifest",
  UpdateRouteEquipmentPreference: "/api/Settings/UpdateRouteTrailerPreference",
  inputShipment: "/filedata/upload/inputShipments",
  trailer: "/filedata/upload/trailerInventory",
  wave: "/filedata/upload/prePlanningData",
  anchor: "/filedata/upload/anchorPoints",
  driver: "/filedata/upload/driverPreference",
  customerSplInst: "/filedata/upload/customerSpecialInstruction",
  freightBill: "/filedata/upload/freightBillDetails",
  UpdateGeofenceData: "/api/Settings/updateGeofencingData",
  UpdateTractorForDispatch: "/api/citydispatch/updateTractorForDispatch",
  UpdateDriverForDispatch: "/api/citydispatch/updateDriverForDispatch",
  CancelDispatch: "/api/dispatch/app/dispatchCancel",
  AssignPickup: "/api/dispatch/app/pickup/assign",
  UnassignPickup: "/api/dispatch/app/pickup/unassign",
  ReassignPickup: "/api/dispatch/app/pickup/reassign",
  AssignDriver: "/api/dispatch/app/assignDriver",
  UpdatePickupStop: "/api/dispatch/app/manifest/pickupCompleted",
  NoFreightPickedUp: "/api/dispatch/app/manifest/noFreightPickedUp",
  CompleteDeliveryStop: "/api/dispatch/app/manifest/deliveryCompleted",
  UpdatePickupData: "/api/citydispatch/updatePickupData",
  PickupOptimize: "/api/dispatch/app/pickup/optimize",
  MessageToDriver: "/api/dispatch/app/message/messageToDriver",
  TrailerHook: "/api/dispatch/app/TrailerHook",
  TrailerDrop: "/api/dispatch/app/TrailerDrop",
  Bobtail: "/api/dispatch/app/Bobtail",
  MoveBills: "/api/dispatch/app/MoveBills",
  DispatcherReadReceipt: "/api/dispatch/app/message/dispatcherReadReceipt",
  VoidPickup: "/api/dispatch/app/pickup/void",
  UnvoidPickup: "/api/dispatch/app/pickup/unvoid",
  UpdatePickupCustomerLocation: "/api/dispatch/app/pickup/updateShipperLocation",
  UpdateDeliveryCustomerLocation: "/api/dispatch/app/customer/updateCustomerLocation",
  saveDispatchRouteStopResequence: "/api/dispatch/app/manifest/stopMove",
  SendDispatchGroupMessages: "/api/dispatch/app/message/sendGroupMessage",
  UpdateCustomerDetail: "/api/customer/updateCustomerDetail",
  UpdateEquipment: "/api/dispatch/app/equipment/UpdateEquipment",
  UpdateTerminalsToMoveEquipment: "/api/dispatch/app/equipment/UpdateTerminalsToMoveEquipment",
  DispatchDriver: "/api/dispatch/app/dispatchDriver",
  RemovePro: "/api/dispatch/app/manifest/deletePro",
  StopsCompleted: "/api/dispatch/app/manifest/stopsCompleted",
  EndOfTrip: "/api/dispatch/app/EndOfTrip",
  AddPro: "/api/dispatch/app/manifest/addPro",
  MarkAsNextStop: "/api/dispatch/app/manifest/nextStopChanged",
  UpdatePickupTerminal: "/api/dispatch/app/pickup/updatePickupTerminal",
  CreatePickup: "/api/dispatch/app/pickup/createPickup",
  EditPickup: "/api/dispatch/app/pickup/editPickup",
  BulkEditPickup: "/api/dispatch/app/pickup/bulkEditPickup",
  BulkVoid: "/api/dispatch/app/pickup/bulkVoid",
  MergePickup: "/api/dispatch/app/pickup/mergePickup",
  DeleteMergedCustomers: "/api/customer/deleteMergedCustomers",
  UpdateProNotes: "/api/dispatch/app/addProNotes",
  SaveTerminal: "/api/settings/loadTerminal",
  AddProToCompletedPickup: "/api/dispatch/app/manifest/addProToCompletedPickup",
  UpdateAccessibleTerminal: "/api/dispatch/app/pickup/updateSplitTerminals",
  SaveCustomerLocationMapping: "/api/customer/saveCustomerLocationMapping",
  DeleteCustomerLocationMapping: "/api/customer/deleteCustomerLocationMapping",
  SaveDeliveryLocationMapping: "/api/customer/saveDeliveryLocationMapping",
  DeleteDeliveryLocationMapping: "/api/customer/deleteDeliveryLocationMapping ",
  UpdateFeederTerminal: "/api/settings/saveFeederTerminal",
  AddShipmentsToPlan: "/api/shipmentselection/addShipmentsToPlan",
  DeleteHoliday: "/api/holiday/deleteHoliday",
  SaveHoliday: "/api/holiday/saveHoliday",
  NoFreightPickup: "/api/dispatch/app/pickup/noFreightForUnassignedPickUp",
  CopyScenario: "/api/Settings/CopyScenario",
  SaveCustomerHolidays: "/api/customer/saveCustomerHolidays",
  DeleteCustomerHolidays: "/api/customer/deleteCustomerHolidays",
  DeleteAndAddPro: "/api/dispatch/app/manifest/deleteAndAddPro",
  BulkUpdateCustomer: '/api/customer/bulkUpdateCustomers',
  DispatchStartTrip :"/api/dispatch/app/startTrip",
  PublishDeliveryReceipt :"/api/reporting/publishDeliveryReceipt",
  SaveCustomerReceiver : "/api/citydispatch/saveCustomerReceiver",
  DeleteCustomerReceiver :"/api/citydispatch/deleteCustomerReceiver",
  UpdateShipmentInPlan :"/api/shipmentselection/updateShipmentStatus",
  UpdateHoldStatus: "/api/terminalSetting/updateHoldStatus",
  UnGroupPickup: "/api/dispatch/app/pickup/ungroupPickup",
  RevisitDeliveryStop: "/api/dispatch/app/manifest/RevisitDeliveryStop",
};

const getDataWithQueryString = (apiName, queryString, options) => {
  const apiUrl = GET_API_URLS[apiName];
  const url = queryString ? `${apiUrl}?${queryString}` : apiUrl;
  return axios.get(url, {...options, apiName}).then((response) => response);
};

const postData = (apiName, dataObject, options) => {
  return axios.post(POST_API_URLS[apiName], dataObject, {...options, apiName}).then((response) => {
    if (response && response.response && response.response.status === 409) {
      Events.emit(appConstant.Event.RESTOREIBSTORE);
    } else if (response.hasReadOnlyRole) {
      return Promise.resolve({status: 403});
    }
    return response;
  });
};

const getDataWithDeduplication = (apiName, queryParams, getLatestQuery=null, abortSignal=null) => {
  return sendRequestWithDeduplication(HTTP_METHOD.GET, apiName, queryParams, getLatestQuery, abortSignal);
};

const postDataWithDeduplication = (apiName, queryParams, getLatestQuery=null, abortSignal=null) => {
  return sendRequestWithDeduplication(HTTP_METHOD.POST, apiName, queryParams, getLatestQuery, abortSignal);
};

const getCancelToken = () => axios.CancelToken;

export {
  getDataWithQueryString,
  postData,
  getCancelToken,
  getDataWithDeduplication,
  postDataWithDeduplication,
}
